module.exports = __webpack_public_path__ + "bb3.no1.912d533d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/aoyama/child_to_parent/bb3.no1.jpg
// module id = HxTF
// module chunks = 0